define('router',['underscore','backbone','jquery','UrlFactory','json!datas/routes.json','site_vars','string'],
    function (_,Backbone,$,UrlFactory,routesUrl,site_vars,S) {

    // constantes
    var router,
        app,
        config,
        BASE_URL = site_vars.base_url,
        API_BASE_URL = routesUrl.API_BASE_URL,
        ISO_LANG = site_vars.iso_lang,
        history = [];

    function unicodeUnescape(string) {
      // replace deprecated `unescape` native function
      return string.replace(/%u([\dA-Z]{4})|%([\dA-Z]{2})/g, function(_, m1, m2) {
        return String.fromCharCode(parseInt("0x" + (m1 || m2)));
      })
    }

    function isIframe() {
        var params = new URLSearchParams(location.search);
        return params.get('i') === '1';
    }

    // TODO factoriser les routes de l’API si elles sont normalisées
    // de type Api*Type*Collection : "*type*"
    // de type Api*Type*Model : "*type*/<%= id_*type* %>"

    // Prevent Uncaught URIError: URI malformed
    Backbone.History.prototype.decodeFragment = function(fragment) {
        try{
            fragment = decodeURI(fragment.replace(/%25/g, '%2525'));
        }catch(e){
            try{
                fragment = decodeURI(unicodeUnescape(fragment.replace(/%25/g, '%2525')));
            }catch(e){
                fragment = '';
            }
        }
        return fragment;
    };

    var Router = Backbone.Router.extend({
        initialize:function(){

            router = this;
            //Backbone.emulateHTTP = true;
        },
        setup:function(appModel){

            app = appModel;
            config = app.getConfigurations();


            // setup initial route in router history
            Backbone.history.start({root: '/', pushState: true});

            // classic ajax loading (partial page refresh)
            router.route(new RegExp('^(('+ISO_LANG+'*)/?(.*))$','i'),'ajaxload');

            //
            // microtemplated pages
            if(!site_vars.ignore_microtemplating){
                //
                var conf = app.c,
                    _PAGE_NEWS_BASE_URL_ = conf('_PAGE_NEWS_BASE_URL_'),
                    _CHECKOUT_BASE_URL_ = conf('_CHECKOUT_BASE_URL_'),
                    _CART_BASE_URL_ = conf('_CART_BASE_URL_'),
                    _STORES_BASE_URL_ = conf('_STORES_BASE_URL_'),
                    checkoutCrossSellingRewrite = conf('_CHECKOUT_CROSS_SELLING_REWRITE_' , 'cross-selling'),
                    $checkoutPaymentRewrite = conf('_CHECKOUT_PAYMENT_REWRITE_' , 'paiement'),
                    checkoutStepsRewrites = [_CART_BASE_URL_,checkoutCrossSellingRewrite,$checkoutPaymentRewrite,'confirmation','error'].join('|'),
                    _CATEGORY_BASE_URL_ = conf('_CATEGORY_BASE_URL_'),
                    widgetGroupsRewrites = [];
                //
                app.getWidgetGroups().each(function(widgetGroup){
                   if(widgetGroup.isPage()){
                       widgetGroupsRewrites.push(widgetGroup.get('link_rewrite'))
                   }
                });
                var microtemplatingRoutes = [
                    '^('+ISO_LANG+'/?)$', // home
                    //'^('+ISO_LANG+'/('+_CART_BASE_URL_+')/?)$', // cart
                    '^('+ISO_LANG+'/('+_CATEGORY_BASE_URL_+')/([a-z0-9-]+)/?)$', // category
                    '^('+ISO_LANG+'/('+_CATEGORY_BASE_URL_+')/([a-z0-9-]+)/[a-z0-9-]+-([0-9]+))?$', // product
                    '^('+ISO_LANG+'/('+conf('_ALL_CATEGORIES_BASE_URL_')+'))/?$', // all-category
                    '^('+ISO_LANG+'/('+_STORES_BASE_URL_+')/(([a-z0-9\-]+)?/?([a-z0-9\-\_\.]+)?))/?$', // store locator
                    '^('+ISO_LANG+'/('+_STORES_BASE_URL_+')/?)/?$', // store locator
                    '^('+ISO_LANG+'/('+conf('_STORE_BASE_URL_')+')/([a-z0-9-]+)?/?([a-z0-9-]+)?)/?$', // store locator
                    '^('+ISO_LANG+'/('+conf('_ACCOUNT_BASE_URL_')+')/?([a-z0-9-]+)?)/?$', // account
                    '^('+ISO_LANG+'/('+conf('_AUTHENTIFICATION_BASE_URL_')+')/?([a-z0-9-]+)?)/?$', // authentification
                    '^('+ISO_LANG+'/('+conf('_PAGE_REORDER_BASE_URL_')+')/?)$', // reorder
                    '^('+ISO_LANG+'/('+_CHECKOUT_BASE_URL_+')/?('+checkoutStepsRewrites+')?)/?$', // checkout Opc
                    '^('+ISO_LANG+'/('+conf('_LOGOUT_REWRITE_')+')/?([a-z0-9-]+)?)/?$', // account logout
                    '^('+ISO_LANG+'/('+conf('_SUPPORT_CENTER_BASE_URL_')+')/?(([a-z]+)-([0-9]+)|[a-z0-9-]*))/?$', // category
                    '^('+ISO_LANG+'/('+_PAGE_NEWS_BASE_URL_+')/?)$', // news
                    '^('+ISO_LANG+'/('+_PAGE_NEWS_BASE_URL_+')/(flag)/([a-z0-9-]+))/?$', // news
                    '^('+ISO_LANG+'/('+_PAGE_NEWS_BASE_URL_+')/([a-z0-9-]+))/?$' // news
                ];
                if(widgetGroupsRewrites.length){
                    microtemplatingRoutes.push(
                        '^('+ISO_LANG+'/('+widgetGroupsRewrites.join('|')+'))/?$' // news
                    );
                }

                // gère les liens internes des groupes de Widget
                //var widgetGroupUrlRewrite = app.get('widgetGroup').getAllUrlRewrite(true);
                //microtemplatingRoutes.push('^('+ISO_LANG+'/('+widgetGroupUrlRewrite.join('|')+'))/?$')

                microtemplatingRoutes.forEach(function(route){
                    var re = new RegExp(route,'i');
                    router.route(re,'microtemplating');
                });
            }

            var initialState = Backbone.history.fragment.toString();
            _(history).push(initialState);

        },
        microtemplating:function(url,page){
            //
            // charge une page via microtemplating
            //
            var options = {}, args = arguments,
                config = app.getConfigurations();
            if(!url){
                url = '/';
            }
            if(!page){
                page = 'Home';
            }

            function cancelListing(){
              app.alert({title:t('Attention','UI'),subtitle:t("Vous devez d'abord choisir une adresse de livraison ou une boutique","Cart")});
                app.go('home');
            }

            if(Modernizr.inapp){
                var deeplink = app.getDeeplink(url);
                if(deeplink){
                    // si on a un deeplink, on va faire matcher.
                    window.location.href = deeplink;
                    return;
                }
            }

            switch(page){

                // page catégorie
                case app.c('_CATEGORY_BASE_URL_') :
                    page = 'Listing';
                    // gestion du cas ou _CATEGORY_BASE_URL_ et _ALL_CATEGORIES_BASE_URL_ sont identiques
                    // si on a pas d'argument 2, on passe au case suivant
                    if(args[2]) {
                        //
                        // route catégorie
                        options = {
                            link_rewrite: args[2]
                        };

                        // route produit
                        if (args[3]) {
                            var id_product = args[3];
                            if(app.getProduct(id_product)){
                                // si le produit existe
                                page = 'Product';
                                options = {
                                    id_product: id_product
                                }
                            }
                        } else {
                            // si le panier n'a pas de boutique on annule le routage
                            //  if(!app.getCart().hasStore()){
                            //      return cancelListing();
                            //  }
                        }
                        break;
                    }

                // page toutes les catégories
                case UrlFactory.getRoute('allCategories') :
                    page = 'Listing';

                    // si le panier n'a pas de boutique on annule le routage
                    //  if(!app.getCart().hasStore()){
                    //      return cancelListing();
                    //  }

                    options = {
                        allCategories : true
                    };
                    break;

                // page mon compte
                case UrlFactory.getRoute('accountDashboard') :
                    page = 'Account';
                    var link_rewrite = args[2];
                    options = {link_rewrite:link_rewrite?link_rewrite:''};
                    break;

                // page panier
                case UrlFactory.getRoute('cart') :
                    page = 'Cart';
                    break;

                // page stores
                case app.c('_STORE_BASE_URL_') :
                    page = 'Store';
                    options = {
                        subpage:'single',
                        url_rewrite : args[2]
                    };
                    break;

                // page store locator listing
                case app.c('_STORES_BASE_URL_') :
                    page = 'Store';
                    options = {
                        subpage:'listing',
                        search_path : args[2] || ''
                    };
                    break;

                // page actu
                case app.c('_PAGE_NEWS_BASE_URL_') :
                    page = 'News';
                    options = {
                        subpage:'list'
                    };
                    if(args[2] === 'flag'){
                        options.flag_link_rewrite = args[3];
                    }else if(args[2]){
                        options.subpage='single';
                        options.news_link_rewrite=args[2];
                    }

                    break;

                // page recommander
                case UrlFactory.getRoute('reorder') :
                    page = 'Reorder';
                    break;

                // page popin authentification
                case UrlFactory.getRoute('authentification') :
                    page = 'Authentification';
                    break;

                // page checkout
                case UrlFactory.getRoute('checkout') :

                    var step_rewrite = args[2] || 'cart';
                    switch(step_rewrite){
                        case 'error':
                        case 'confirmation':
                            page = 'CheckoutConfirmation';
                            break;
                        default:
                            page = 'CheckoutOpc';
                            break;
                    }
                    options.step_rewrite = step_rewrite;
                    break;

                case UrlFactory.getRoute('supportCenter'):
                    if(app.c('_USE_ZENDESK_CONTACT_',0)==1){
                        page = 'SupportCenter';
                        var query = args[2],
                            ressource = args[3],
                            ressourceId = args[4];
                        if(ressource && ressourceId){
                            options = {
                                type: ressource,
                                id: ressourceId
                            }
                        }else if(query){
                            options = {
                                type: 'search',
                                id: query
                            }
                        }else{
                            options = {
                                type: null,
                                id: null
                            }
                        }
                    }else{
                        page = 'Contact';
                        if(args[2]){
                            options = {
                                subpage : args[2]
                            };
                        }
                    }

                    break;

                // se déconnecter
                case UrlFactory.getRoute('logout') :
                    app.trigger('applyLogout');
                    return;

                default:
                    if(app.getWidgetGroups().findWhere({link_rewrite:page})){
                        options = {link_rewrite:page};
                        page = 'Widget';
                    }
                    break;

            }
            try{
                if(app.getHybridRouting().usePageReload(url,page,options)){
                    // rolling start reload
                    var redirect = BASE_URL.replace(/\/?$/,'')+url.replace(/^\/*/,'/');
                    window.location.href = redirect;
                }else{
                    router.trigger('displayMicrotemplating',url,page,options);
                }
            }catch(err){
                window.onerror(err,0,0,0,err);
                if (site_vars.env === "dev") {
                    throw err;
                }
            }
        },
        ajaxload:function(url){
            //
            // charge une page en ajax
            //
            //
            $.ajax({url:router.getBaseUrl()+url,dataType:'html',method:'get',data:{ajax:true}}).done(function(data,status,xhr){
                //
                // vérifie que la route est toujours identique
                // car le chargement ajax est asynchrone
                if(status === 'success' && Backbone.history.fragment == url) {
                    router.trigger('ajaxloaded', data, xhr, url);
                }
                //
            }).fail(function(){
                app.alert();
            });
        },
        currentRoute:function(){
          return Backbone.history.fragment.toString();
        },
        category:function(category){
            router.trigger('templateCategory',category);
        },
        getBaseUrl:function(){
            return site_vars.base_url;
        },
        getRouteUrl:function(id_route,ignoreBaseUrl,ignoreLang){
            if(id_route === 'home' && app.useHomePageWithoutLangPrefix()){
                ignoreLang = true;
            }
            return _.template((ignoreBaseUrl?'':BASE_URL)+(ignoreLang?'':ISO_LANG.toLowerCase()+'/')+routesUrl[id_route]);
        },
        getPictureUrl:function(id_picture,model,pictureType,rewrite, extension){
            if(_.isUndefined(id_picture) || !parseInt(id_picture)) return;
            if(_.isUndefined(pictureType)) return;
            if(_.isUndefined(rewrite)) rewrite = model.toLowerCase();
            var suffix,
                options;
            if (pictureType === 'origin' || pictureType === 'noscale'){
                // pour les images origin et noscale (des formats spéciaux, statiques, non redimensionnés)
                extension = extension.toString().toLowerCase();
                suffix = pictureType;
            } else {
                extension = pictureType.get('format').toString().toLowerCase();
                suffix = pictureType.get('suffix');
            }
            options = {
                id_picture:id_picture,
                rewrite:S(rewrite).slugify().slice(0,30),
                model:model.toLowerCase(),
                extension:extension,
                suffix:suffix
            };
            var path = _.template(routesUrl['picture'])(options);
            return UrlFactory.getDomainShardingImgUrl(path);
        },
        getApiRouteUrl:function(id_route,ignoreBaseUrl){
            return _.template((ignoreBaseUrl?'':BASE_URL+API_BASE_URL)+routesUrl[id_route]);
        },
        go:function(route,reload, trigger){
            // alias à la fonction Backbone.Router.navigate(path, {trigger: true})
            if (isIframe()){
                parent.postMessage({
                    event: "navigate",
                    url: route,
                }, "*")
            } else {
                if(reload){
                    // force un rechargement de page
                    window.location.replace(route);
                }else if (trigger || trigger === undefined || typeof trigger === undefined){
                    router.navigate(route || "",{trigger:true});
                }else{
                    router.navigate(route || '',{trigger:false});
                }
            }
        },
        pushState:function(state){
            if (isIframe()){
                parent.postMessage({
                    event: "navigate",
                    url: "",
                }, "*");
            } else {
                //Backbone.history.history.pushState(null,null,state);
                router.navigate(state,{trigger:false,replace:false})
                // Backbone.history.pushState(state,null,state);
            }
        },
        back:function(){
            //Backbone.history.back();
        }
    });

    // router singleton
    return new Router();
});
